import { define, RuleCMSWidgetElement, RULECMS_WIDGET_TAG } from './rulecms-widget-element';
import { mount, unmount } from './mount';
import type { RuleCMSWidgetEmbedOptions } from './types';
import { version } from './version';

export type { RuleCMSWidgetEmbedOptions };
export {
  define,
  mount,
  unmount,
  RuleCMSWidgetElement,
  RULECMS_WIDGET_TAG,
  version,
};

/** Convenience namespace for script-tag / IIFE hosts (`window.RuleCMS`). */
export const Widget = {
  define,
  mount,
  unmount,
  tag: RULECMS_WIDGET_TAG,
  version,
};

// Auto-register when the bundle loads in a browser.
define();
